const ENDPOINT = '/user';

export default axios => ({
  setHeaders() {
    axios.defaults.headers.common['X-Authorization'] = this.getToken();
  },

  removeHeaders() {
    axios.defaults.headers.common = {};
  },

  checkProfileRole() {
    // Temporary solution
    const profile = localStorage.getItem('profile');

    if (profile) {
      const profileObj = JSON.parse(profile);

      if (profileObj.group[0].fgname === 'admins') {
        return true;
      }
    }

    return false;
  },

  /**
   * Check if token is not expired
   * @return {*}
   */
  checkTokenAlive() {
    return axios.get(`${ENDPOINT}/check_alive`);
  },
});



// WEBPACK FOOTER //
// ./src/services/auth.service.js